import React, { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { PRESETS, presetRange } from "@/lib/format";

export function DateRangeControl({ value, onChange }) {
  const [customOpen, setCustomOpen] = useState(false);
  const [range, setRange] = useState({ from: value?.start, to: value?.end });

  const applyPreset = (key) => {
    if (key === "custom") { setCustomOpen(true); return; }
    const r = presetRange(key);
    onChange({ preset: key, start: r.start, end: r.end });
  };

  const applyCustom = () => {
    if (range?.from && range?.to) {
      const start = new Date(range.from); start.setHours(0, 0, 0, 0);
      const end = new Date(range.to); end.setHours(23, 59, 59, 999);
      onChange({ preset: "custom", start, end });
      setCustomOpen(false);
    }
  };

  return (
    <div className="flex sm:flex-wrap items-center gap-1.5 overflow-x-auto no-scrollbar -mx-1 px-1 pb-1" data-testid="date-range-control">
      {PRESETS.map((p) => {
        const active = value?.preset === p.key;
        if (p.key === "custom") {
          return (
            <Popover key={p.key} open={customOpen} onOpenChange={setCustomOpen}>
              <PopoverTrigger asChild>
                <button
                  data-testid="date-range-preset-custom"
                  className={`inline-flex shrink-0 whitespace-nowrap items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors ${active ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"}`}
                >
                  <CalendarIcon className="h-3.5 w-3.5" />
                  {active && value?.start ? `${format(new Date(value.start), "MMM d")} – ${format(new Date(value.end), "MMM d")}` : "Custom"}
                </button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-3" align="end">
                <Calendar mode="range" selected={range} onSelect={setRange} numberOfMonths={2} />
                <div className="flex justify-end mt-2">
                  <Button size="sm" onClick={applyCustom} data-testid="apply-custom-range-btn">Apply</Button>
                </div>
              </PopoverContent>
            </Popover>
          );
        }
        return (
          <button
            key={p.key}
            data-testid={`date-range-preset-${p.key}`}
            onClick={() => applyPreset(p.key)}
            className={`text-xs font-semibold shrink-0 whitespace-nowrap px-3 py-1.5 rounded-full border transition-colors ${active ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"}`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
